import React, { Component } from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import ModalOverlay from "../../../../components/UI/ModalOverlay";
import theme from '../../../../Theme/theme';
import Spinner from '../../../../components/LoadingSpinner';
import SearchBox from "../../../../components/SearchBox";
import { API_URL, ERROR_HANDLE } from "config/constants";
import { getExpiryDuration, sortDataByDate } from '../../../../common/Utils'

const SEARCH_TEXT = "Search by promo code"
const NO_PROMO_CODE_FOUND = "No promo code found"

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            promocodeList: [],
            filteredPromocode: [],
            isLoading: true
        }
    }

    componentDidMount() {
        this.props.promocodeList.length > 0 ?
            this.setState({ promocodeList: this.props.promocodeList, filteredPromocode: this.props.promocodeList, isLoading: false }) : this.getPromocodeList();
    }

    getPromocodeList() {
        const access_token = localStorage.getItem("access_token");
        axios
            .get(`${API_URL}/promos?status=active`, {
                headers: {
                    "x-access-token": access_token
                }
            }).then(res => {
                if (!res.error) {
                    const promocodeList = sortDataByDate(res.data);
                    this.setState({
                        promocodeList,
                        filteredPromocode: promocodeList,
                        isLoading: false
                    }, () => {
                        this.props.updatePromocodeList(this.state.promocodeList);
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                    this.setState({ isLoading: false })
                }
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    renderSearchButton = () => {
        return (
            <div style={style.searchContainer}>
                <SearchBox
                    hideSearchImage={true}
                    placeholder={SEARCH_TEXT}
                    searchWrapperStyle={style.searchWrapper}
                    searchInputStyle={style.searchInput}
                    onChange={(e) => this.searchHandler(e)}>
                </SearchBox>
            </div>
        );
    }

    renderPromocodeList() {
        return (
            this.state.filteredPromocode.length > 0 ? <div style={style.container}>
                <div style={style.promocodeTitleContainer}>
                    <div style={style.promocodeTitle}>Promocode</div>
                    <div style={style.promocodeTitle}>Quantity</div>
                    <div style={style.promocodeTitle}>Validity</div>
                </div>
                {this.state.filteredPromocode.map((promocode, index) => {
                    const quantity = promocode.qty || ""
                    return (
                        promocode.promocode && <div key={"promocodeContainer" + promocode.promo_id} style={style.promocodeNameContainer} onClick={() => this.props.updateSelectedPromoCode(promocode)}>
                            <div key={"promoListName" + promocode.promo_id} style={style.promocodeName}>{promocode.promocode}</div>
                            <div key={"promoListQuantity" + promocode.promo_id} style={style.promocodeName}>{quantity}</div>
                            <div key={"promoListTo" + promocode.promo_id} style={style.promocodeName}>{getExpiryDuration(promocode.to)}</div>
                        </div>
                    )
                })}
            </div> : <div style={{ ...style.container, ...style.alertContainer }}>{NO_PROMO_CODE_FOUND}</div>
        )
    }

    searchHandler = (e) => {
        const filteredPromocode = this.state.promocodeList.filter(promocode => {
            const promocodeName = promocode.promocode;
            return promocodeName && promocodeName.toLowerCase().includes(e.target.value.toLowerCase())
        })
        this.setState({ filteredPromocode })
    }

    render() {
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> :
                <ModalOverlay
                    modalStyle={style.modalStyle}
                    header="Promocode List"
                    headerStyle={style.headerStyle}
                    headerBodyStyle={style.headerBodyStyle}
                    bodyStyle={style.modalBody}
                    underLayerStyle={style.underLayer}
                    close={this.props.close}
                >
                    <div>
                        {this.renderSearchButton()}
                        {this.renderPromocodeList()}
                    </div>
                </ModalOverlay>
        )
    }
}

Modal.propTypes = {
    promocodeList: PropTypes.array.isRequired,
    updatePromocodeList: PropTypes.func.isRequired,
    updateSelectedPromoCode: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired
};

const style = {
    container: {
        display: 'flex',
        width: 500,
        height: 350,
        overflowY: "auto",
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.color.white,
        borderRadius: 3,
        marginBottom: 8
    },
    modalStyle: {
        backgroundColor: theme.color.transparent
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        height: 60,
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        backgroundColor: theme.color.red,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.textLightWhite,
    },
    modalBody: {
        width: "100%",
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    button: {
        width: "100%",
        height: 60,
        fontSize: 31,
        letterSpacing: 0,
        lineHeight: "60px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.textLightWhite,
        backgroundColor: theme.color.primaryPink,
        borderRadius: 5,
        borderWidth: 0
    },
    promocodeTitleContainer: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
        backgroundColor: theme.color.lightPrimaryBlue,
        borderBottom: "2px solid " + theme.color.borderGrey
    },
    promocodeTitle: {
        fontSize: 20,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        color: theme.color.thickGrey,
        textAlign: 'center',
        paddingTop: 10,
        paddingBottom: 10
    },
    promocodeNameContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 60,
        width: "100%",
        backgroundColor: theme.color.white,
        borderBottom: "2px solid " + theme.color.tableSeparatorGrey
    },
    promocodeName: {
        fontSize: 17,
        width: "90%",
        verticalAlign: "middle",
        textAlign: "center",
        letterSpacing: 0,
        lineHeight: "60px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontFamily: theme.font.avenirMedium,
        color: theme.color.thickGrey
    },
    alertContainer: {
        height: 150,
        justifyContent: "center",
        fontSize: 26,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        textAlign: 'center',
        background: theme.color.white
    },
    searchContainer: {
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "1px 2px 4px " + theme.color.shadowColor,
        lineHeight: "60px",
        backgroundColor: theme.color.white
    },
    searchWrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
        width: "90%",
        position: "relative"
    },
    searchInput: {
        backgroundColor: theme.color.lightGrey,
        borderRadius: 32,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: theme.color.white,
        fontSize: 20,
        fontFamily: theme.font.avenirHeavyOblique,
        color: theme.color.searchTextGrey,
        width: "100%",
        paddingLeft: 20,
        textAlign: "left"
    }
};

export default Modal;

